module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "mouseleave": _vm.searchFocus
    }
  }, [(_vm.isDesktop) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "What are you looking for?",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": _vm.search,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, function($event) {
        !_vm.bannerPlaceHolderForSearchSuggestions && _vm.autosuggest()
      }],
      "focusout": function($event) {
        _vm.resetWidthIncrementHandler()
      },
      "focusin": function($event) {
        _vm.searchHistoryHandler()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "display": "inline-block",
      "visibility": "hidden",
      "position": "fixed",
      "overflow": "auto",
      "font-size": "14px"
    },
    attrs: {
      "id": "searchCopy"
    }
  }), _vm._v(" "), (_vm.showImageSearchWeb && _vm.enableVincenzeSearch && _vm.isSelectedCountryIndia) ? _c('label', {
    staticClass: "camera-icon"
  }, [_c('input', {
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageSearchHandler($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-camera"
  })]) : _vm._e(), _vm._v(" "), (_vm.isSearchMikeShow) ? _c('span', {
    staticClass: "fa fa-microphone mic-icon",
    class: _vm.isSpeechRecognising ? 'mic-icon-red' : '',
    on: {
      "click": _vm.startDictation
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isExclusive) ? _c('img', {
    staticClass: "search-white icon",
    class: [_vm.isSearchMikeShow ? 'search-btn-margin' : '', !['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(_vm.callerComp) ? 'dnone' : ''],
    attrs: {
      "src": require("../../assets/images/search-white.png")
    },
    on: {
      "click": _vm.submitSearch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isExclusive) ? _c('span', {
    staticClass: "d-flex icon"
  }, [(_vm.isNewSearch) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/search-black.svg"),
      "alt": "search",
      "width": "18",
      "height": "20"
    },
    on: {
      "click": _vm.submitSearch
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/mship-search.svg"),
      "alt": "search",
      "width": "20",
      "height": "24"
    },
    on: {
      "click": _vm.submitSearch
    }
  })]) : _c('div', [(_vm.isNewSearch) ? _c('span', {
    staticClass: "fa icon mr-1",
    class: [_vm.isSearchMikeShow ? 'search-btn-margin' : '', ['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(_vm.callerComp) ? 'dnone' : ''],
    on: {
      "click": _vm.submitSearch
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/search-black.svg"),
      "alt": "search",
      "width": "18",
      "height": "20"
    }
  })]) : _c('span', {
    staticClass: "fa fa-search icon",
    class: [_vm.isSearchMikeShow ? 'search-btn-margin' : '', ['supimaMenu', 'winterWearMenu', 'activeWearMenu'].includes(_vm.callerComp) ? 'dnone' : ''],
    on: {
      "click": _vm.submitSearch
    }
  })]), _vm._v(" "), _c('autoCompleteList', {
    attrs: {
      "trigger": _vm.trigger,
      "categories": this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay ? this.searchHistoryCategories : this.categories,
      "heightClass": _vm.heightVal,
      "searchListWidth": _vm.searchListWidth,
      "isSearchHistory": this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay,
      "isShowTopSellProduct": _vm.isShowTopSellProduct && _vm.isSearchTopSellingProductShow,
      "isShowNewArrivalProduct": _vm.isShowNewArrivalProduct && _vm.isSearchNewArrivalProductShow
    },
    on: {
      "demo": _vm.demo,
      "searchEventHandler": function($event) {
        _vm.searchHistoryResponder($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isDesktop) ? _c('div', [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-input"
  }, [_c('span', {
    staticClass: "fa fa-arrow-left search-input-icons",
    on: {
      "click": function($event) {
        _vm.searchBack()
      }
    }
  }), _vm._v(" "), (_vm.showImageSearchMSite && _vm.enableVincenzeSearch && _vm.isSelectedCountryIndia) ? _c('label', {
    staticClass: "camera-icon ml-2 mr-2"
  }, [_c('input', {
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageSearchHandler($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-camera"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "searchinput",
    class: _vm.isSearchMikeShow ? 'search-input-w-65' : '',
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search for Products?",
      "autocomplete": "off",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keyup": _vm.search,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, function($event) {
        !_vm.bannerPlaceHolderForSearchSuggestions && _vm.autosuggest()
      }],
      "focusin": function($event) {
        _vm.searchHistoryHandler()
      }
    }
  }), _vm._v(" "), (_vm.showEraseButton) ? _c('span', {
    staticClass: "fa fa-close search-input-icons",
    on: {
      "click": _vm.clearSearch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSearchMikeShow) ? _c('div', {
    staticClass: "micbutton",
    on: {
      "click": _vm.startDictation
    }
  }, [_c('span', {
    staticClass: "fa fa-microphone mic-icon-mobile",
    class: _vm.isSpeechRecognising ? 'mic-icon-red' : ''
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searchbutton",
    on: {
      "click": _vm.submitSearch
    }
  }, [_c('span', {
    staticClass: "fa fa-search search-input-icons"
  })]), _vm._v(" "), _c('autoCompleteList', {
    attrs: {
      "trigger": _vm.trigger,
      "categories": this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay ? this.searchHistoryCategories : this.categories,
      "heightClass": _vm.heightVal,
      "searchListWidth": _vm.searchListWidth,
      "isSearchHistory": this.bannerPlaceHolderForSearchHistory && this.isSearchHisDisplay,
      "isShowTopSellProduct": false,
      "isShowNewArrivalProduct": false
    },
    on: {
      "demo": _vm.demo,
      "searchEventHandler": function($event) {
        _vm.searchHistoryResponder($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "spinner-3-wrapper"
  }, [_c('img', {
    staticClass: "spinner-3",
    attrs: {
      "src": _vm.staticImgServer + 'assets/spinner-3.gif',
      "alt": "Loader"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-txt"
  }, [_vm._v("Awesomeness Loading")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "recommendations-section"
  }, [(_vm.isSearchNewArrivalProductShow && _vm.autoSuggestRecomProduct && _vm.autoSuggestRecomProduct.new_arrival_products && _vm.autoSuggestRecomProduct.new_arrival_products.length) ? _c('div', {
    staticClass: "search-containers"
  }, [_c('h4', {
    staticClass: "search-page-headers"
  }, [_vm._v("New Launches")]), _vm._v(" "), _c('div', {
    staticClass: "row product-card-slide"
  }, _vm._l((_vm.autoSuggestRecomProduct.new_arrival_products), function(newProducts, index) {
    return _c('div', {
      key: index,
      staticClass: "search-product-cards col-6"
    }, [(newProducts.images) ? _c('img-block', {
      staticClass: "product-card-img-block",
      attrs: {
        "parry": newProducts.images,
        "imageH": 400,
        "imageW": 300,
        "urlKey": newProducts.product_slug,
        "productTitle": newProducts.product,
        "isStockConfig": newProducts.prodQty,
        "pstock": newProducts.stock,
        "jitValue": newProducts.jitValue,
        "listCat": newProducts.category.name,
        "productCat": newProducts.artist,
        "productPrice": newProducts.price,
        "exclusivePrice": newProducts.exclusivePrice,
        "spprice": newProducts.splPrice || newProducts.spl_price,
        "scrollToProduct": _vm.scrollNow,
        "showImageBlurSoldOutDesign": true,
        "callerComp": "Search Suggestions"
      },
      nativeOn: {
        "click": function($event) {
          _vm.searchNewArrivalProductClickEvent(newProducts)
        }
      }
    }) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.isSearchTopSellingProductShow && _vm.autoSuggestRecomProduct && _vm.autoSuggestRecomProduct.top_selling_products && _vm.autoSuggestRecomProduct.top_selling_products.length) ? _c('div', {
    staticClass: "search-containers"
  }, [_c('h4', {
    staticClass: "search-page-headers"
  }, [_vm._v("Trending Products")]), _vm._v(" "), _c('div', {
    staticClass: "row product-card-slide"
  }, _vm._l((_vm.autoSuggestRecomProduct.top_selling_products), function(newProducts, index) {
    return _c('div', {
      key: index,
      staticClass: "search-product-cards col-6"
    }, [(newProducts.images) ? _c('img-block', {
      staticClass: "product-card-img-block",
      attrs: {
        "parry": newProducts.images,
        "imageH": 400,
        "imageW": 300,
        "urlKey": newProducts.product_slug,
        "productTitle": newProducts.product,
        "isStockConfig": newProducts.prodQty,
        "pstock": newProducts.stock,
        "jitValue": newProducts.jitValue,
        "listCat": newProducts.category.name,
        "productCat": newProducts.artist,
        "productPrice": newProducts.price,
        "exclusivePrice": newProducts.exclusivePrice,
        "spprice": newProducts.splPrice || newProducts.spl_price,
        "scrollToProduct": _vm.scrollNow,
        "showImageBlurSoldOutDesign": true,
        "callerComp": "Search Suggestions"
      },
      nativeOn: {
        "click": function($event) {
          _vm.searchTopSellingProductClickEvent(newProducts)
        }
      }
    }) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), (!_vm.bannerPlaceHolderForSearchWidgets && _vm._cart && _vm._cart.products && _vm._cart.products.items && _vm._cart.products.items.length) ? _c('div', {
    staticClass: "search-containers"
  }, [_c('h4', {
    staticClass: "search-page-headers"
  }, [_vm._v("Forgot something in your bag ?")]), _vm._v(" "), _c('div', {
    staticClass: "forgot-something"
  }, [_c('span', {
    staticClass: "forgot-something-wrapper",
    on: {
      "click": function($event) {
        _vm.productClick(_vm._cart.products.items[0].category_id === 611 ? '/exclusive' : _vm._cart.products.items[0].url_key, _vm._cart.products.items[0])
      }
    }
  }, [_c('div', {
    staticClass: "forget-something-img-block"
  }, [_c('img', {
    attrs: {
      "data-src": _vm.IMG_URL + _vm.path + this._cart.products.items[0].images[0],
      "alt": "Forgot Something"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "forget-something-product-details"
  }, [_c('p', {
    staticClass: "cartItem-product-name"
  }, [_vm._v(_vm._s(this._cart.products.items[0].product))]), _vm._v(" "), _c('p', {
    staticClass: "cartItem-product-category"
  }, [_vm._v(_vm._s(this._cart.products.items[0].category))]), _vm._v(" "), (this._cart.products.items[0].spl_price) ? _c('span', [_c('span', {
    staticClass: "cartItem-special-price"
  }, [_vm._v("₹ " + _vm._s(this._cart.products.items[0].spl_price))]), _vm._v(" "), _c('span', {
    staticClass: "cartItem-product-price"
  }, [_vm._v("₹ " + _vm._s(this._cart.products.items[0].price))])]) : _c('span', [_vm._v("₹ " + _vm._s(this._cart.products.items[0].price))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary  btn-block pointer text-uppercase view-bag",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToCart()
      }
    }
  }, [_vm._v("View Bag")])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd204e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/autocomplete.vue
// module id = 1166
// module chunks = 0 19 112 113 114